module.exports = __webpack_public_path__ + "img/shutterstock_600464906.36c4e8ec.jpg";